import(/* webpackMode: "eager" */ "/vercel/path0/apps/aura/src/app/global-error.tsx");
